function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import Icon from './Icon';
const ShapeTriangleIcon = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(Icon, _extends({
  "data-testid": "shapeTriangle",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.33,20.75H3.22a.75.75,0,0,1-.65-1.12l9.06-16a.75.75,0,0,1,.65-.38h0a.75.75,0,0,1,.65.38l9.05,16a.75.75,0,0,1-.65,1.12ZM4.51,19.25H20.05L12.28,5.52Z"
})));
ShapeTriangleIcon.displayName = 'ShapeTriangleIcon';
ShapeTriangleIcon.renderIcon = props => /*#__PURE__*/React.createElement(ShapeTriangleIcon, props);
export default ShapeTriangleIcon;
//# sourceMappingURL=ShapeTriangleIcon.js.map